import { I18nType } from '@/ui/types/i18n.types';
import { ObjectLike } from '@/types/objectlike.types';

const componentName = 'forms';
const submodule = 'errors';
const mega = 1000000;

export default function fileSizeRule(i18n: I18nType) {
  return function rule(property: string, maxSize = 3000000) {
    return [
      (v: ObjectLike) => !v || v.size < maxSize || i18n.getFormattedText(componentName, submodule, 'fileSize', { property, size: maxSize / mega }),
    ];
  };
}
